import { render } from "./Products.vue?vue&type=template&id=6e585baf&scoped=true"
import script from "./Products.vue?vue&type=script&lang=js"
export * from "./Products.vue?vue&type=script&lang=js"

import "./Products.vue?vue&type=style&index=0&id=6e585baf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e585baf"]])

export default __exports__